module.exports = __webpack_public_path__ + "static/bg-band-d25a9a7ec858f5dc124b8776f47c932b.jpg";